#import "./ContractFields.graphql"

mutation CreateContract(
  $attributes: ContractAttributesInput!
  $status: ContractStatusEnum
) {
  createContract(input: { attributes: $attributes, status: $status }) {
    contract {
      ...ContractFields
    }
  }
}
